import React, { useEffect, useState } from 'react';
import { LITTER_DEFAULT_IMAGE, LITTERS_ADMIN_PREFIX } from '../../../../utils/constants';
import { LitterInterface } from '../../admin-dashboard-tables/interfaces';
import DateHelper from '../../../../utils/DateHelper';
import EditSVG from '../../admin-dashboard-tables/assets/EditSVG';
import { cloudinaryTransform } from '../../../../utils/cloudinaryTransformations';

interface Props extends LitterInterface {
  id: number,
  status: string,
  selected: Array<number>,
  toggleSelected: (id: number) => void,
  allowBulkSelect?: boolean,
  onToggleExtraCallback?: (extraData?: any) => any,
}

const LitterHit: React.FC<Props> = ({
  id,
  admin_breed_display,
  thumbnailUrl,
  route,
  created_at,
  listings,
}) => {
  const [windowHref, setWindowHref] = useState(window.location.href);

  useEffect(() => {
    let newWindowHref = window.location.href;
    newWindowHref = newWindowHref.replace(/&/g, '|amp|');
    if (windowHref !== newWindowHref) {
      setWindowHref(newWindowHref);
    }
  }, [windowHref, window.location.href]);

  return (
    <div className="border-bottom d-flex py-2">
      <div className="td-image my-auto">
        <img
          className="rounded img-fluid"
          height="60"
          width="60"
          alt={`A ${admin_breed_display} litter.`}
          src={thumbnailUrl
            ? cloudinaryTransform(
              thumbnailUrl,
              [
                't_lpr-full-transform',
                'c_thumb,h_60,w_60',
              ],
            ) : LITTER_DEFAULT_IMAGE}
        />
      </div>
      <div className="w-100 td-info px-2 text-nowrap justify-content-between">
        <div className="left">
          <a
            className="text-auto"
            href={route}
          >
            <p className="mb-0 puppy-name text-auto">{`Litter ${id}`}</p>
          </a>
          <p className="text-auto m-0 text-muted"><small>{admin_breed_display}</small></p>
          <p className="text-auto m-0 text-muted">
            <small>
              Posted:
              {' '}
              {DateHelper.getLocalizedDateTimeFromTimestamp(created_at).format('M/D/Y')}
            </small>
          </p>
        </div>
        <div className="right">
          <p className="mb-0 puppy-name">
            {`${listings.length}${listings.length === 1 ? ' Ad' : ' Ads'}`}
          </p>
          <p className="m-0 fa-xs">
            {' '}
            {listings.filter((listing) => listing.availability === 'pending').length}
            {' '}
            Pending
          </p>
          <p className="m-0 fa-xs">
            {' '}
            {listings.filter((listing) => listing.availability === 'sold').length}
            {' '}
            Sold
          </p>
        </div>
      </div>
      <div className="my-auto mx-2">
        <a
          href={`${LITTERS_ADMIN_PREFIX}/${id}/edit`}
          className="mx-2 my-auto btn badge badge-pill badge-blue-200 font-family-sans-serif border my-2 px-3"
        >
          <span className="d-flex align-items-center p-1">
            <EditSVG />
            <span className="ml-1">Edit</span>
          </span>
        </a>
      </div>
    </div>
  );
};

export default LitterHit;
